import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';
import { DataManager } from '../../core/data-manager';
import { toast } from 'react-toastify';
import VoyageDocuments from './VoyageDocuments';


export default function DGLTH_voyage_double({ item, entity = null, refreshData }) {

    useEffect(() => {
        //console.warn(item)
    }, []);


    async function deleteVoyage() {
        var res = await DataManager.deleteItem('voyage', item.id);
        if(res.success === 1){
            toast.success("Viaggio eliminato con successo!", {theme: 'colored'})
            refreshData()
        }else{
            toast.error("Errore nella eliminazione del viaggio!", {theme: 'colored'})
        }
    }

    async function ignoreVoyage() {
        var body = {
            ignoreDouble : 1
        }
        var res = await DataManager.updateItem('voyage', body, item.id);
        if(res.success === 1){
            toast.success("Viaggio ignorato con successo!", {theme: 'colored'})
            refreshData()
        }else{
            toast.error("Errore nell'ignorare il viaggio duplicato!", {theme: 'colored'})
        }
    }



    return (
        <>
            <div className='d-flex flex-row'>
                <Button variant='outline-primary' size='sm' className='me-1' onClick={() => ignoreVoyage()}>Ignora</Button>
                <Button variant='outline-danger' size='sm' onClick={() => deleteVoyage()}>Elimina</Button>
            </div>


        </>
    )
};